import moment from 'moment';
const dayMillseconds = 86400 * 1000;

export default {
    props: {
    },
    data() {
        return {
            sortNotifications:[],
        };
    },
    computed: {
        initialized() {
            return this.$store.state.userinfo.initialized;
        },
        isLogin() {
            return this.$store.state.userinfo.isLogin;
        },
        isShow() {
            // 忽略驗證是否有登入的頁面，不顯示開獎直播通知
            return !this.$route.meta.ignoreAuth;
        },
    },
    methods: {
        checkStartTime(time){
            var now = moment();
            return now >moment().startOf('day').add(moment.duration(time.Start)) && now< moment().startOf('day').add(moment.duration(time.End));
        },

        async initNotifications(){
            let _this = this;
            const origNotifications = await $.get('/api/LiveNotify/LotteryLiveNotifyInfo');

            for(var i = 0; i< origNotifications.length; i++){
                let timeout = dayMillseconds;
                let tomorrowTimeout = 0;
                let isToday = false;
                let isAdd = false;
                for(var j = 0; j< origNotifications[i].NotifyTimes.length; j++){
                    var timespan = origNotifications[i].NotifyTimes[j];
                    //先確認是否已經在時間區間內，是的話就add，如果沒有的話就查詢下一次距離現在最短的開始時間
                    if(_this.checkStartTime(timespan))
                    {
                        _this.add(origNotifications[i]);
                        isAdd = true;
                        break;
                    }
                    else{
                        let nextStartTime = moment().startOf('day').add(moment.duration(timespan.Start)) - moment();
                        // 如果找到任一找到後相減為正的，就代表今天還有時段沒跑到，從這裏面選取差值最小的
                        // 如果相減以後的數字全為負數，就代表需要跑明天的排程，選擇相差最大的數字加上86400秒
                        if(nextStartTime > 0 && timeout > nextStartTime){
                            timeout = nextStartTime;
                            isToday = true;
                        }
                        else if(nextStartTime < 0 && tomorrowTimeout > nextStartTime){
                            tomorrowTimeout = nextStartTime;
                        }
                    }
                }
                if(!isAdd){
                    if(isToday){
                        _this.reserveAdd(origNotifications[i], timeout);
                    }
                    else{
                        _this.reserveAdd(origNotifications[i], tomorrowTimeout + dayMillseconds);
                    }
                }
            }
        },
        remove(obj){
            var pos = this.sortNotifications.indexOf(obj);
            //避免手動刪除與自動刪除造成重複預約添加同一個通知
            if(pos != (-1)){
                this.sortNotifications.splice(pos,1);
                let timeout = this.checkNextStartTime(obj);
                this.reserveAdd(obj,timeout);
            }

        },
        add(obj){
            this.sortNotifications.push(obj);
            let timeout = this.checkNextEndTime(obj);
            this.reserveRemove(obj,timeout);
        },
        reserveRemove(obj, timeout){
            setTimeout(() => this.remove(obj), timeout);
        },
        reserveAdd(obj, timeout){
            setTimeout(() => this.add(obj), timeout);
        },
        //每次關閉的時候都要抓出下次的顯示時間並設定timeout
        checkNextStartTime(obj){
            let timeout = dayMillseconds;
            let tomorrowTimeout = 0;
            let isToday = false;
            for(var i = 0; i< obj.NotifyTimes.length; i++){
                var timespan = obj.NotifyTimes[i];
                let nextStartTime = moment().startOf('day').add(moment.duration(timespan.Start)) - moment();
                if(nextStartTime > 0 && timeout > nextStartTime){
                    timeout = nextStartTime;
                    isToday = true;
                }else if(nextStartTime < 0 && tomorrowTimeout > nextStartTime){
                    tomorrowTimeout = nextStartTime;
                }
            }
            if(isToday)
                return timeout;
            else
                return tomorrowTimeout + dayMillseconds;
        },
        checkNextEndTime(obj){
            //預設會在同一天內結束，不考慮跨日，所以只需要計算相減後大於零的場合
            let timeout = dayMillseconds;
            for(var i = 0; i< obj.NotifyTimes.length; i++){
                var timespan = obj.NotifyTimes[i];
                let nextEndTime = moment().startOf('day').add(moment.duration(timespan.End)) - moment();
                if(nextEndTime > 0 && timeout > nextEndTime){
                    timeout = nextEndTime;
                }
            }
            return timeout;
        },

        goToBetPage(obj) {
            this.$router.push('/Bet/' + obj.GameId);
            this.remove(obj);
        },
    },
    watch: {
        async initialized(val) {
            if (val && this.isLogin)
                await this.initNotifications();
        }
    }
};